<template>
  <div
    style="height: 615px"
    ref="pointsCompanyTab"
    :key="keyCounter"
    class="tw-relative"
  >
    <BaseLoader v-if="localLoading" style="z-index: 100"></BaseLoader>

    <div class="tw-my-[15px] tw-flex tw-gap-[10px] tw-items-center">
      <div class="tw-flex tw-gap-[10px] tw-items-center">
        <span class="tw-text-[14px] tw-text-forTitle tw-font-semibold">
          Баллов
        </span>
        <span class="tw-text-[20px] tw-py-[8px] tw-px-[15px] tw-text-[#23B14D]">
          {{ data.totalScore }}
        </span>
      </div>

      <button
        class="tw-app-btn-primary-outline"
        @click="$modal.show('AccrueCompanyPoints')"
      >
        Начислить
      </button>
      <AccrueCompanyPoints @update="getWithFilter()" :modalInfo="modalInfo" />

      <button
        class="tw-app-btn-primary-outline"
        @click="setRemoveCompanyPoints()"
      >
        <img
          :src="require(`@/assets/icons/minus-dark.svg`)"
          width="13.5"
          height="13.5"
          class="tw-my-[-5px]"
        />
        Удалить
      </button>
      <RemoveCompanyPoints
        @update="(activeSelectRowsMultiple = []), getWithFilter()"
        :modalInfo="modalInfo"
      />

      <button class="tw-app-btn-primary-outline" @click="loadExel()">
        <img
          :src="require(`@/assets/icons/excel-dark.svg`)"
          width="16"
          height="16"
          class="tw-my-[-5px]"
        />
        в Excel
      </button>
    </div>

    <div class="tw-flex tw-justify-between tw-mb-[15px]">
      <div class="tw-flex">
        <button @click="getWithFilter()" class="tw-app-btn-primary-outline">
          Отфильтровать
        </button>
        <button
          @click="resetFilter()"
          class="tw-app-btn-light !tw-text-[#0056AF]"
        >
          Сбросить фильтр
        </button>
      </div>

      <TwBasePagination
        :page-count="data.total / data.limit"
        :pagination-params="data"
        :page-range="10"
        :showLimitInput="false"
        :margin-pages="0"
        :click-handler="getWithFilter"
      >
      </TwBasePagination>
    </div>

    <ve-table
      class="rest-style-table"
      style="width: 100%"
      :columns="columns"
      :table-data="data?.rows || []"
      :border-x="true"
      :border-y="true"
      row-key-field-name="company_scores__id"
      :checkbox-option="{
        hideSelectAll: false,
        selectedRowChange: selectedRowChange,
        selectedAllChange: selectedAllChange,
      }"
      :clickHighlight="false"
      :rowStyleOption="{
        hoverHighlight: true,
      }"
      :cellSelectionOption="{ enable: false }"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import AccrueCompanyPoints from "./AccrueCompanyPoints.vue";
import RemoveCompanyPoints from "./RemoveCompanyPoints.vue";
import dayjs from "dayjs";

export default {
  components: {
    VeTable,
    AccrueCompanyPoints,
    RemoveCompanyPoints,
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  data() {
    return {
      keyCounter: 0,
      activeSelectRowsMultiple: [],
      data: {},
      currentPage: 0,
      localLoading: false,
      filters: {
        company_scores__description: {
          value: null,
          operator: "like",
        },
        company_scores__score: {
          value: null,
          operator: "like",
        },
      },
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState("userSettingModule", ["userSetting"]),
    columns() {
      return [
        {
          field: "",
          key: "a",
          type: "checkbox",
          title: "",
          width: "3%",
          align: "center",
        },
        {
          field: "company_scores__created_at",
          key: "company_scores__created_at",
          title: "Дата",
          align: "center",
          width: "10%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.company_scores__created_at
                  ? dayjs(row.company_scores__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "company_scores__score",
          key: "company_scores__score",
          title: "Рейтинг",
          align: "center",
          width: "10%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span
                class={
                  row.company_scores__score < 0
                    ? `tw-text-forTitle`
                    : `tw-text-[#23B14D]`
                }
              >
                {row.company_scores__score}
              </span>
            );
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <span>{column.title}</span>
                <BaseInputNew
                  onKeyupEnter={this.getWithFilter}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.setFilter}
                  inputName={"company_scores__score"}
                />
              </div>
            );
          },
        },
        {
          field: "company_scores__description",
          key: "company_scores__description",
          title: "Основание",
          align: "center",
          width: "50%",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <span>{column.title}</span>
                <BaseInputNew
                  onKeyupEnter={this.getWithFilter}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.setFilter}
                  inputName={"company_scores__description"}
                />
              </div>
            );
          },
        },
        {
          field: "company_scores__created_by",
          key: "company_scores__created_by",
          title: "Кто добавил",
          align: "center",
        },
        {
          field: "company_scores__life_to",
          key: "company_scores__life_to",
          title: "Сгорают",
          align: "center",
          width: "10%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.company_scores__life_to
                  ? dayjs(row.company_scores__life_to)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },
      ];
    },
  },
  methods: {
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      callback(true, nameTab, oldTab, newTab, flagIsClose);
    },
    selectedRowChange({ selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    setRemoveCompanyPoints() {
      if (this.activeSelectRowsMultiple?.length) {
        this.$modal.show("RemoveCompanyPoints");
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    setFilter(data) {
      this.filters[data.name].value = data.value;
    },
    getWithFilter(page) {
      const where = Object.entries(this.filters)
        .filter(([, config]) => config.value)
        .map(([field, config]) => ({
          field,
          value:
            config.operator === "like"
              ? `;percent;${config.value};percent;`
              : config.value,
          ...(config.operator && { operator: config.operator }),
        }));
      this.getData(where, page);
    },
    resetFilter() {
      for (let key in this.filters) {
        if (this.filters.hasOwnProperty(key)) {
          this.filters[key].value = null;
        }
      }
      this.getData();
      this.keyCounter++;
    },
    getData(where = [], page = 1) {
      this.localLoading = true;
      GeneralService.get(
        `/super/companies/tab/score/table/list/${this.modalInfo.id}`,
        {
          params: {
            where: JSON.stringify(where),
            page: page,
            limit: 14,
          },
        }
      )
        .then((data) => {
          this.data = data.data.data;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        })
        .finally(() => {
          this.localLoading = false;
        });
    },
    async loadExel() {
      let dataFrom = await GeneralService.toSpecExcel(
        `/super/companies/tab/score/table/xlsx/${this.modalInfo.id}`
      );
      const filename = new Date().toISOString();
      const url = window.URL.createObjectURL(dataFrom.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  },
};
</script>
